import axios from "axios";
import qs from "qs";

import productsMixin from "../../mixins/common/productsMixin";
import utilMixin from "../../mixins/common/utilMixin";
import {
  getStripeProductById,
  saveStripeProduct
} from "@/collections/stripeProducts";
import {
  getStripeSkuByProductPriceAndName,
  saveStripeSku
} from "@/collections/stripeSkus";
import { saveUserCart } from "@/collections/userCart";

let redsysCards = window.localStorage.getItem("redsysCards");
let cart = window.localStorage.getItem("cart");
let admincart = window.localStorage.getItem("admincart");
let stripeCheckoutItems = window.localStorage.getItem("stripeCheckoutItems");

const STRIPE_API_URL = process.env.VUE_APP_STRIPE_API_URL;
const ENDPOINT_STRIPE_PRODUCTS = `${STRIPE_API_URL}/products`;
const ENDPOINT_STRIPE_SKUS = `${STRIPE_API_URL}/skus`;

const state = {
  cart: cart ? JSON.parse(cart) : [],
  admincart: admincart ? JSON.parse(admincart) : [],
  stripeCheckoutItems: stripeCheckoutItems
    ? JSON.parse(stripeCheckoutItems)
    : [],
  stripeSkuConfig: {
    options: {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRIPE_PRIVATE_KEY}`,
        "content-type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    },
    currency: "eur",
    inventory: {
      type: "infinite"
    }
  },
  redsysCards: redsysCards ? JSON.parse(redsysCards) : []
};

const mutations = {
  updateStripeCheckoutItems(state) {
    if (utilMixin.areStripeVariablesEmpty()) {
      return;
    }

    state.stripeCheckoutItems = [];

    state.cart.forEach(item => {
      state.stripeCheckoutItems.push({
        product_id: item.product_id,
        product_type_id: item.product_type_id,
        sku: item.stripeSku,
        quantity: item.quantity
      });
    });

    window.localStorage.setItem(
      "stripeCheckoutItems",
      JSON.stringify(state.stripeCheckoutItems)
    );
  },
  async addStripeProduct(_state, stripeProduct) {
    try {
      if (utilMixin.areStripeVariablesEmpty()) {
        return;
      }

      await saveStripeProduct(stripeProduct.product_id, {
        name: stripeProduct.name,
        product: stripeProduct.product,
        product_id: stripeProduct.product_id,
        type: stripeProduct.type
      });
    } catch (error) {
      this.setlogError(
        "save_stripe_product",
        "Obtained error message in addStripeProduct()",
        error.stack,
        this.$options.name
      );
    }
  },
  async addStripeSku(_state, stripeSku) {
    try {
      if (utilMixin.areStripeVariablesEmpty()) {
        return;
      }

      await saveStripeSku(stripeSku.id, {
        sku: stripeSku.id,
        product: stripeSku.product,
        price: stripeSku.price,
        product_id: stripeSku.product_id,
        name: stripeSku.name
      });
    } catch (error) {
      this.setlogError(
        "save_stripe_sku",
        "Obtained error message in addStripeSku()",
        error.stack,
        this.$options.name
      );
    }
  },
  addRedsysCards(state, data) {
    let found = state.redsysCards.some(item => {
      if (item.identifier === data.identifier) {
        return item;
      }
    });
    if (!found) {
      state.redsysCards.push(data);
      window.localStorage.setItem(
        "redsysCards",
        JSON.stringify(state.redsysCards)
      );
    }
  },
  saveRedsysCardData(state) {
    window.localStorage.setItem(
      "redsysCards",
      JSON.stringify(state.redsysCards)
    );
  },
  updateStripeProductIndCart(state, item) {
    let productInCart = getProductInCart(item, state);
    if (!productInCart) {
      return;
    }

    this.commit("saveData", { item: item });
  },
  async updateStripeSkuIndCart(state, item) {
    try {
      let productInCart = getProductInCart(item, state);
      if (!productInCart) {
        return;
      }

      productInCart.stripeSku = item.stripeSku;
      let uniqueId = "_id" + new Date().getTime();
      productInCart.id = uniqueId;
      !state.userProfile?.roles &&
        (await saveUserCart(uniqueId, productInCart));
      this.commit("saveData", { item: item });
    } catch (error) {
      this.setlogError(
        "save_user_cart",
        "Obtained error message in updateStripeSkuIndCart()",
        error.stack,
        this.$options.name
      );
    }
  }
};

const actions = {
  createProductInStripe({ commit, dispatch, state }, item) {
    if (utilMixin.areStripeVariablesEmpty()) {
      return;
    }

    let params = qs.stringify({
      name: item.name,
      type: "good",
      attributes: ["name"]
    });

    axios
      .post(ENDPOINT_STRIPE_PRODUCTS, params, state.stripeSkuConfig.options)
      .then(response => {
        commit("addStripeProduct", {
          product_id: item.product_id,
          name: response.data.name,
          product: response.data.id,
          type: response.data.type,
          cart_type:
            item.cart_type !== undefined && item.cart_type === "admin"
              ? item.cart_type
              : ""
        });

        commit("updateStripeProductIndCart", {
          order: item.order,
          stripeProduct: response.data.id,
          cart_type:
            item.cart_type !== undefined && item.cart_type === "admin"
              ? item.cart_type
              : ""
        });

        dispatch("addStripeSkuToCart", {
          price: item.price,
          name: item.name,
          product_id: item.product_id,
          order: item.order,
          stripeProduct: response.data.id,
          stripeSku: null,
          cart_type:
            item.cart_type !== undefined && item.cart_type === "admin"
              ? item.cart_type
              : ""
        });
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error);
      });
  },
  createSkuInStripe({ commit, state }, item) {
    if (utilMixin.areStripeVariablesEmpty()) {
      return;
    }

    let price = productsMixin.stripeFormatPrice(item.price);
    let params = qs.stringify({
      price: price,
      attributes: {
        name: item.order
      },
      currency: state.stripeSkuConfig.currency,
      inventory: state.stripeSkuConfig.inventory,
      product: item.stripeProduct,
      active: true
    });

    axios
      .post(ENDPOINT_STRIPE_SKUS, params, state.stripeSkuConfig.options)
      .then(response => {
        commit("addStripeSku", {
          id: response.data.id,
          product: item.stripeProduct,
          price: price,
          product_id: item.product_id,
          name: item.order
        });

        commit("updateStripeSkuIndCart", {
          order: item.order,
          stripeSku: response.data.id,
          cart_type:
            item.cart_type !== undefined && item.cart_type === "admin"
              ? item.cart_type
              : ""
        });
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error);
      });
  },
  addStripeProductToCart({ commit, dispatch, state }, item) {
    let productInCart = getProductInCart(item, state);
    if (!productInCart || productInCart.stripeProduct) {
      return;
    }

    getStripeProductById(item.product_id)
      .then(stripeProduct => {
        if (stripeProduct) {
          commit("updateStripeProductIndCart", {
            order: item.order,
            stripeProduct: stripeProduct.product,
            cart_type:
              item.cart_type !== undefined && item.cart_type === "admin"
                ? item.cart_type
                : ""
          });
          dispatch("addStripeSkuToCart", {
            price: item.price,
            name: item.name,
            product_id: item.product_id,
            order: item.order,
            stripeProduct: stripeProduct.product,
            stripeSku: null,
            cart_type:
              item.cart_type !== undefined && item.cart_type === "admin"
                ? item.cart_type
                : ""
          });
        } else {
          dispatch("createProductInStripe", item);
        }
      })
      .catch(error => {
        this.setlogError(
          "get_stripe_product_by_id",
          "Obtained error message in addStripeProductToCart()",
          error.stack,
          this.$options.name
        );
      });
  },
  addStripeSkuToCart({ commit, dispatch, state }, item) {
    let productInCart = getProductInCart(item, state);
    if (!productInCart || productInCart.stripeSku) {
      return;
    }

    getStripeSkuByProductPriceAndName(
      item.product_id,
      productsMixin.stripeFormatPrice(item.price),
      item.order
    )
      .then(sku => {
        if (sku) {
          commit("updateStripeSkuIndCart", {
            order: item.order,
            stripeSku: sku,
            cart_type:
              item.cart_type !== undefined && item.cart_type === "admin"
                ? item.cart_type
                : ""
          });
        } else {
          dispatch("createSkuInStripe", item);
        }
      })
      .catch(error => {
        this.setlogError(
          "get_stripe_sku_by_product_price_and_name",
          "Obtained error message in addStripeSkuToCart()",
          error.stack,
          this.$options.name
        );
      });
  }
};

const getters = {};

function getProductInCart(item, state) {
  if (item.cart_type !== "" && item.cart_type && item.cart_type === "admin") {
    return state.admincart.find(product => product.order === item.order);
  } else {
    return state.cart.find(product => product.order === item.order);
  }
}

export default {
  state,
  mutations,
  actions,
  getters
};
